import Phaser from 'phaser'
import {
    CST
} from '../CST'
import BoardScene from './BoardScene2';
import BoardScene3 from './BoardScene3';
import BoardScene4 from './BoardScene4';
import QuestionScene from './QuestionScene';

var clickSound;

export default class EndScreenScene extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.ENDSCREEN)
    }

    preload() {}

    create(data) {

        clickSound = this.sound.add("clickSound");
        for (let index = 0; index < data.array.length; index++) {
            if (data.array[index][1] < 10) {
                data.array[index][1] = " " + data.array[index][1];
            }
        }

        const boardScene = this.scene.get(data.scene);

        boardScene.scene.stop();
        boardScene.scene.remove();

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'blank_background');


        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;
        //this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2) - 120, 'game_over_text');

        switch (data.scene) {
            case "BOARD2":
                this.scene.add(data.scene, BoardScene, false);

                this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'leaderboard2');

                this.add.text(screenCenterX - 300, (screenCenterY - 155), data.array[0][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 155), data.array[0][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY - 60), data.array[1][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 60), data.array[1][1], CST.TEXTSTYLES.TEAMLEADERBOARD);
                break;
            case "BOARD3":
                this.scene.add(data.scene, BoardScene3, false);

                this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'leaderboard3');

                this.add.text(screenCenterX - 300, (screenCenterY - 155), data.array[0][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 155), data.array[0][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY - 60), data.array[1][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 60), data.array[1][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY + 35), data.array[2][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY + 35), data.array[2][1], CST.TEXTSTYLES.TEAMLEADERBOARD);
                break;
            case "BOARD4":
                this.scene.add(data.scene, BoardScene4, false);

                this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'leaderboard4');

                this.add.text(screenCenterX - 300, (screenCenterY - 155), data.array[0][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 155), data.array[0][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY - 60), data.array[1][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY - 60), data.array[1][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY + 35), data.array[2][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY + 35), data.array[2][1], CST.TEXTSTYLES.TEAMLEADERBOARD);

                this.add.text(screenCenterX - 300, (screenCenterY + 130), data.array[3][0], CST.TEXTSTYLES.TEAMLEADERBOARD);
                this.add.text(screenCenterX + 210, (screenCenterY + 130), data.array[3][1], CST.TEXTSTYLES.TEAMLEADERBOARD);
                break;
        }

        const menu = this.add.image(this.cameras.main.width / 2 - 150, (this.cameras.main.height / 2 + 300), 'btn_menu');
        menu.setInteractive({
            useHandCursor: true
        });
        menu.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop();
            var menu = this.scene.get(CST.SCENES.MENU);
            menu.scene.restart();
        });

        const play_again = this.add.image(this.cameras.main.width / 2 + 150, (this.cameras.main.height / 2) + 300, 'btn_play_again');
        play_again.setInteractive({
            useHandCursor: true
        });
        play_again.on("pointerdown", () => {
            clickSound.play();
            this.scene.stop();
            this.scene.start(data.scene, {
                data: data.names,
                replay: 0
            });
        });
    }
}